<template>
    <main class="-mt-32">
        <div class="px-4 py-10 pb-12 mx-auto -mt-32 max-w-7xl sm:px-6 lg:px-8">
            <div class="overflow-hidden bg-white shadow sm:rounded-md">
                <div class="px-4 py-4 sm:px-6">
                    <div class="flex rounded-md shadow-sm">
                        <div class="relative flex-grow focus-within:z-10">
                            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <svg
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    class="w-5 h-5 text-gray-400"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
                                        clip-rule="evenodd"
                                    ></path>
                                </svg>
                            </div>
                            <input
                                v-model="query"
                                class="block w-full pl-10 transition duration-150 ease-in-out rounded-none form-input rounded-l-md sm:text-sm sm:leading-5"
                            />
                        </div>
                        <router-link
                            tag="button"
                            :to="`/clients/new`"
                            class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium leading-5 text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-r-md hover:bg-indigo-500 focus:outline-none"
                        >
                            <svg
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                class="w-5 h-5"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                            <span class="ml-2">Azienda</span>
                        </router-link>
                    </div>
                </div>
                <div class="main-container">
                    <ul
                        v-if="filtered.length"
                        class="scrollable"
                        @scroll="scroll"
                    >
                        <li
                            v-for="client in filtered"
                            :key="client.id"
                            class="border-t border-gray-200"
                        >
                            <router-link
                                :to="`/clients/${client.id}`"
                                class="block transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
                            >
                                <div class="flex items-center px-4 py-4 sm:px-6">
                                    <div class="flex items-center flex-1 min-w-0">
                                        <div class="flex-1 min-w-0 px-4 md:grid md:grid-cols-2 md:gap-4">
                                            <div>
                                                <div class="text-sm font-medium leading-5 text-indigo-600 truncate">
                                                    {{ client.name }}
                                                </div>
                                                <client-email
                                                    v-if="client.email"
                                                    :email="client.email"
                                                />
                                                <client-phone
                                                    v-if="client.phone"
                                                    :phone="client.phone"
                                                />
                                                <client-mobile
                                                    v-if="client.mobile"
                                                    :mobile="client.mobile"
                                                />
                                            </div>
                                            <div class="hidden md:block">
                                                <div>
                                                    <div class="text-sm leading-5 text-gray-900">
                                                        <span v-if="client.vat">
                                                            PIVA {{ client.vat }}
                                                        </span>
                                                        <span v-if="client.fiscal_cod">
                                                            CF {{ client.fiscal_code }}
                                                        </span>
                                                    </div>
                                                    <div class="flex items-center mt-2 text-sm leading-5 text-gray-500">
                                                        {{ client.address}} {{ client.zip }} {{ client.city}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <svg
                                            class="w-5 h-5 text-gray-400"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                                clip-rule="evenodd"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { mapState } from "vuex";
import ClientEmail from "./ClientEmail";
import ClientPhone from "./ClientPhone";
import ClientMobile from "./ClientMobile";

export default {
    props: {
        history: {
            required: false
        }
    },

    data: () => {
        return {
            loaded: false,
            query: "",
            elements: 0,
            pagination: 50,
            page: 1
        };
    },

    components: {
        ClientEmail,
        ClientPhone,
        ClientMobile
    },

    computed: {
        ...mapState("client", ["clients"]),
        filtered() {
            this.loaded;
            return _.filter(this.clients, client =>
                client.name.toUpperCase().includes(this.query.toUpperCase())
            )
                .sort(function(a, b) {
                    return a.name.toUpperCase() > b.name.toUpperCase()
                        ? 1
                        : b.name.toUpperCase() > a.name.toUpperCase()
                        ? -1
                        : 0;
                })
                .slice(0, this.page * this.pagination);
        }
    },

    methods: {
        scroll() {
            let container = $(".main-container");
            let height = container.scrollHeight - container.offsetHeight;
            let scrollTop = container.scrollTop;
            if (
                this.page * this.pagination < this.elements &&
                height - scrollTop < container.offsetHeight
            ) {
                this.page++;
            }
        }
    },

    async mounted() {
        await this.$store.dispatch("client/CLIENTS");
        this.elements = Object.keys(this.clients).length;
        this.loaded = true;
    }
};
</script>
